<template>
  <div
    :aria-label="paymentMethod.label"
    class="border-static-default-low rounded-md border border-solid p-24"
  >
    <header class="flex items-start justify-between">
      <div class="flex items-center">
        <div class="mr-8 max-w-[3rem]">
          <RevIllustration
            :alt="paymentMethod.label"
            :height="27"
            :src="paymentMethod.logoLink.params.value"
            :width="48"
          />
        </div>
        <h2 class="heading-2">
          {{ paymentMethod.label }}
        </h2>
      </div>

      <div class="flex items-center">
        <RevButton
          v-if="paymentMethod.hasSettings"
          class="mr-16 px-12 py-8"
          :icon="IconGear"
          size="small"
          variant="secondary"
          with-icon
          @click="handleOpenSettings"
        >
          {{ i18n(translations.settings) }}
        </RevButton>

        <IconCheckInCircle
          v-if="paymentMethod.active"
          :aria-label="i18n(translations.active, { name: paymentMethod.label })"
          class="text-static-success-hi scale-[1.2]"
        />
        <IconCrossInCircle
          v-if="!paymentMethod.active"
          :aria-label="
            i18n(translations.inactive, { name: paymentMethod.label })
          "
          class="text-static-danger-hi scale-[1.2]"
        />
      </div>
    </header>
    <div class="mt-12">
      <span class="body-1">
        {{ paymentMethod.description }}
      </span>
      <p class="body-1-bold mt-12">
        {{ i18n(translations.availableIn) }}
      </p>
      <div class="mt-8 flex items-center">
        <Flag
          v-for="countryCode in paymentMethod.availableMarkets"
          :key="countryCode"
          :aria-label="i18n.country(countryCode)"
          class="mr-8"
          :country-code
          size="l"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { merchantsAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconCrossInCircle } from '@ds/icons/IconCrossInCircle'
import { IconGear } from '@ds/icons/IconGear'

import translations from './PaymentMethodCard.translations'

const props = defineProps<{
  paymentMethod: merchantsAPI.PaymentMethod
}>()

const emit = defineEmits(['settings-clicked'])

const i18n = useI18n()

function handleOpenSettings() {
  emit('settings-clicked', props.paymentMethod.name)
}
</script>
